export default __webpack_public_path__ + "static/gm-logo-6e0166a9ad86bd8c9ee5df9a8fd25fdf.png";